import LoggerAwareViewModel from './LoggerAwareViewModel';

const AuthCallbackViewModel = LoggerAwareViewModel.named('BasePresenter').actions((self) => ({
    userDataDidGet(isAnonymous: boolean) {},
}));

export default AuthCallbackViewModel;
